<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { get_data_attr } from '@/utils/globals'
import { useI18n } from 'vue-i18n'
import { useToast, Toaster} from "@/components/ui/toast"

const { toast } = useToast()
const { t } = useI18n()
const specsInfo = get_data_attr("specs")

const selectedItem = ref(null)

const showRight = ref(false) // controls visibility of right panel

// props for parent events
const props = defineProps({
})

// --- Splitter + width logic ---
const containerRef = ref(null)
const leftWidth = ref(100) // start full width (right panel hidden)
const isDragging = ref(false)

function adjustWidths() {
  if (!containerRef.value) return
  const fullWidth = containerRef.value.clientWidth
  leftWidth.value = showRight.value ? (fullWidth * 0.7) / fullWidth * 100 : 100
}

// --- Main toggle logic ---
const setSelected = async (item) => {
  selectedItem.value = item
  nextTick(() => adjustWidths())
}

defineExpose({
  showRight,
  setSelected,
});

// --- Splitter dragging ---
const startDrag = (e) => { e.preventDefault(); isDragging.value = true }
const stopDrag = () => { isDragging.value = false }

const onDrag = (e) => {
  if (!isDragging.value) return
  const rect = containerRef.value.getBoundingClientRect()
  let newLeft = ((e.clientX - rect.left) / rect.width) * 100
  if (newLeft < 10) newLeft = 10
  if (newLeft > 90) newLeft = 90
  leftWidth.value = newLeft
}

onMounted(() => {
  window.addEventListener('mousemove', onDrag)
  window.addEventListener('mouseup', stopDrag)
})
onBeforeUnmount(() => {
  window.removeEventListener('mousemove', onDrag)
  window.removeEventListener('mouseup', stopDrag)
})

</script>

<template>
  <div ref="containerRef" class="flex h-screen w-full overflow-hidden">
    <!-- Left Panel -->
	<Toaster />
    <div class="p-4 overflow-auto" :style="{ width: leftWidth + '%' }">
		<slot name="leftcontent" />
    </div>

    <!-- Splitter -->
    <div
      v-if="showRight"
      class="w-1 md:w-2 bg-gray-300 hover:bg-gray-400 cursor-col-resize"
      @mousedown="startDrag"
      @touchstart.prevent="startDrag"
      @touchmove.passive="(e)=>{ if (e.touches && e.touches[0]) onDrag(e.touches[0]) }"
      @touchend="stopDrag"
      style="touch-action: none;"
    ></div>

    <!-- Right Panel -->
    <div
      v-if="showRight"
      class="p-4 overflow-auto transition-all duration-300"
      :style="{ width: (100 - leftWidth) + '%' }"
    >
	<slot name="rightcontent" :row="selectedItem"/>
    </div>
  </div>
</template>
